module.exports = __webpack_public_path__ + "img/calendar-tick.65f02d4f.svg";